import MatrixPrintHook from './matrix_print.js';
import { AvailabilityOverlay } from './availability_overlay.js';
import { ResolutionDetectorHook } from './resolution_detector.js';
import { ResolutionListenerHook } from './resolution_listener.js';
import { ResolutionDetectorMenuCalendarHook } from './resolution_detector_menu_calendar.js';
import { FormValidator } from './form_validator.js';
import { ClientSelectionManager } from './client_selection_manager.js';
import { TenantClientSelector } from './tenant_client_selector.js';
import { SupportTicketContext } from './support_ticket_context.js';
import { MicrositeHooks } from './microsite_runtime.js';
import { ReservationUiHooks } from './reservation_ui.js';
import { LiveViewUiHooks } from './liveview_ui.js';
import { LiveViewMiscRuntimeHooks } from './liveview_misc_runtime.js';
import { FormRuntimeHooks } from './form_runtime.js';
import { KioskValidationHooks } from './kiosk_validation_errors.js';
import { KioskOpsRuntimeHooks } from './kiosk_ops_runtime.js';
import { AdvancedVisualRuntimeHooks } from './advanced_visual_runtime.js';
import { QuestionnaireNavigation } from './questionnaire_navigation.js';
import { DeviceConnectionHook } from '../runtime/device_connection.js';
import {
  AbsoluteMonitorAccessUrl,
  AbsoluteSecureDeviceUrl
} from './monitor_capability_bootstrap.js';

const NavigationHooks = require('./navigation');

export const buildHooksRegistry = () => {
  const Hooks = {};
  Hooks.DeviceConnection = DeviceConnectionHook;
  Hooks.AvailabilityOverlay = AvailabilityOverlay;

  Hooks.InfiniteScroll = LiveViewMiscRuntimeHooks.InfiniteScroll;
  Hooks.BackupMealPickerHook = LiveViewMiscRuntimeHooks.BackupMealPickerHook;
  Hooks.ResolutionDetector = ResolutionDetectorHook;
  Hooks.ResolutionDetectorMenuCalendar = ResolutionDetectorMenuCalendarHook;
  Hooks.ResolutionListener = ResolutionListenerHook;
  Hooks.ModalManager = LiveViewMiscRuntimeHooks.ModalManager;
  Hooks.LiveSearch = LiveViewMiscRuntimeHooks.LiveSearch;
  Hooks.FormValidator = FormValidator;
  Hooks.ClientSelectionManager = ClientSelectionManager;
  Hooks.TenantClientSelector = TenantClientSelector;
  Hooks.SupportTicketContext = SupportTicketContext;
  Hooks.Twemoji = LiveViewMiscRuntimeHooks.Twemoji;
  Hooks.FlashDismiss = LiveViewMiscRuntimeHooks.FlashDismiss;

  Hooks.ChartJS = AdvancedVisualRuntimeHooks.ChartJSHook;
  Hooks.AuditChart = Hooks.ChartJS;
  Hooks.HelpPanel = AdvancedVisualRuntimeHooks.HelpPanel;
  Hooks.ReservationsPrint = AdvancedVisualRuntimeHooks.ReservationsPrint;

  Hooks.PreserveCheckboxes = LiveViewMiscRuntimeHooks.PreserveCheckboxes;
  Hooks.IndeterminateCheckbox = LiveViewMiscRuntimeHooks.IndeterminateCheckbox;
  Hooks.MatrixPrint = MatrixPrintHook;
  Hooks.HelpTour = AdvancedVisualRuntimeHooks.HelpTour;
  Hooks.AutoDismissFlash = LiveViewMiscRuntimeHooks.AutoDismissFlash;
  Hooks.Clipboard = LiveViewMiscRuntimeHooks.Clipboard;
  Hooks.DepartmentTree = LiveViewMiscRuntimeHooks.DepartmentTree;
  Hooks.PrintPreview = LiveViewMiscRuntimeHooks.PrintPreview;
  Hooks.PrintPreviewTrigger = LiveViewMiscRuntimeHooks.PrintPreviewTrigger;
  Hooks.MealSelector = LiveViewMiscRuntimeHooks.MealSelector;
  Hooks.MenuCalendarOrientation = LiveViewMiscRuntimeHooks.MenuCalendarOrientation;

  Hooks.CalendarAnimations = ReservationUiHooks.CalendarAnimations;
  Hooks.MicrositeCalendarGestures = MicrositeHooks.MicrositeCalendarGestures;
  Hooks.EdgeSwipeBack = MicrositeHooks.EdgeSwipeBack;
  Hooks.RfidCapture = AdvancedVisualRuntimeHooks.RfidCapture;
  Hooks.ModalTabs = ReservationUiHooks.ModalTabs;
  Hooks.SessionTimeout = KioskValidationHooks.SessionTimeout;
  Hooks.ValidationErrors = KioskValidationHooks.ValidationErrors;
  Hooks.RfidHeightAdjust = KioskOpsRuntimeHooks.RfidHeightAdjust;
  Hooks.MenuLevelsSortable = KioskOpsRuntimeHooks.MenuLevelsSortable;

  Hooks['microsite-hooks'] = Hooks.ValidationErrors;

  Hooks.HierarchyNav = NavigationHooks.HierarchyNav;
  Hooks.BreadcrumbsResponsive = NavigationHooks.BreadcrumbsResponsive;
  Hooks.Alpine = LiveViewMiscRuntimeHooks.AlpineHook;
  Hooks.FileDownload = LiveViewUiHooks.FileDownload;
  Hooks.DiningHallDropdown = LiveViewUiHooks.DiningHallDropdown;
  Hooks.DashboardTabs = LiveViewUiHooks.DashboardTabs;
  Hooks.MicrositeQR = MicrositeHooks.MicrositeQR;
  Hooks.AuthLayoutSync = MicrositeHooks.AuthLayoutSync;
  Hooks.KioskTechAccess = LiveViewMiscRuntimeHooks.KioskTechAccess;
  Hooks.ClearFormError = FormRuntimeHooks.ClearFormError;
  Hooks.PreventFormReset = FormRuntimeHooks.PreventFormReset;
  Hooks.DirectFileInput = FormRuntimeHooks.DirectFileInput;
  Hooks.QuestionnaireNavigation = QuestionnaireNavigation;
  Hooks.AbsoluteMonitorAccessUrl = AbsoluteMonitorAccessUrl;
  Hooks.AbsoluteSecureDeviceUrl = AbsoluteSecureDeviceUrl;

  return Hooks;
};
